import React from "react";
import {
  DemoWorkbenchCard,
  DemoWorkbenchCopy,
  DemoWorkbenchNotice,
  DemoWorkbenchPill,
  DemoWorkbenchStack,
} from "@csk/demo-ui";
import {
  CONSERVATION_LAWS,
  everyConservationLawHolds,
} from "./conservation-panel/conservationLawModel.js";

const ConservationPanel = (): React.JSX.Element => {
  const laws = CONSERVATION_LAWS;
  const allPass = everyConservationLawHolds(laws);

  return (
    <DemoWorkbenchStack>
      <DemoWorkbenchCard title="Conservation Law Verification (§12.8.6)">
        <DemoWorkbenchCopy>
          Conservation laws are evaluated against the current GL(n) governance
          matrix.
        </DemoWorkbenchCopy>
      </DemoWorkbenchCard>
      <DemoWorkbenchNotice
        tone={allPass ? "success" : "danger"}
        title={allPass ? "ALL CONSERVATION LAWS HOLD" : "FORGERY DETECTED"}
        className="text-center"
      >
        {allPass
          ? "Governance matrix is authentic — mathematical invariants verified."
          : "Conservation law violated — governance matrix may be corrupted."}
      </DemoWorkbenchNotice>

      <DemoWorkbenchStack gap={12}>
        {laws.map((law, i) => (
          <DemoWorkbenchCard
            key={i}
            compact
            title={law.name}
            right={
              <DemoWorkbenchPill variant={law.match ? "success" : "danger"}>
                {law.match ? "PASS" : "FAIL"}
              </DemoWorkbenchPill>
            }
          >
            <DemoWorkbenchCopy tone="muted">{law.shortName}</DemoWorkbenchCopy>
            {law.lhs !== null && law.rhs !== null && (
              <DemoWorkbenchCopy size="xs" tone="muted" className="mt-1">
                LHS = {law.lhs.toFixed(4)} | RHS = {law.rhs.toFixed(4)}
              </DemoWorkbenchCopy>
            )}
            <DemoWorkbenchCopy size="xs" tone="muted" className="mt-1 italic">
              {law.interpretation}
            </DemoWorkbenchCopy>
          </DemoWorkbenchCard>
        ))}
      </DemoWorkbenchStack>

      <DemoWorkbenchCopy size="xs" tone="muted">
        These are theorems of GL(n), not design choices. Any violation means the
        governance matrix has been tampered with. Detection latency: O(n³) per
        check.
      </DemoWorkbenchCopy>
    </DemoWorkbenchStack>
  );
};

export default ConservationPanel;
